module.exports = __webpack_public_path__ + "img/collection-diamondJewelryRedgold@2x.32c8df5.jpg";